module.exports = __webpack_public_path__ + "static/yoox-dynamic-format-1-03bb2bd3c954add087fbf1a204e98693.mp4";